import React from 'react';
import { OmniTooltipNextComponent, OmniIconComponent} from '../../../../shared/components/omni-components';
import { PlacementDetailsTableService } from '../../';
import '../../../../styles/placementDetailsTableSummaryHeader.css';


class PlacementDetailsTableSummaryHeader extends React.Component {

    constructor(props) {
        super(props)
    }

    no_value = "0.00";
    
    /*
    * Function to get the sum of the given column
    * @param {String} column - column name
    * @returns {Number} - sum of the column
    */ 
    getSum = (column) => {
        const items = this.props.data;
        return items.reduce((prev, curr) => {
            if(!['Child', 'DSP', 'Delivered', 'DirectCreative', 'Ad Server', 'Ad Verification', 'FeeOrder'].includes(curr.package_type)){
                let total = prev;
                if(curr[column])
                    total += Number(curr[column]);
                return total;
            }
            else return prev;    
        }, 0);
    }

    currencyFractionDigits = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).resolvedOptions().maximumFractionDigits;

    convertIntoCurrency(value,currencyName){
        let strPrice = Number(value);
        return strPrice.toLocaleString('en-US', { style: "currency", currency: currencyName });
    }
    
    render() {
        let plannedCost = 'planned_cost';
        let totalBudget = 'campaign_total_budget';
        let campaignFees = 'campaign_fees';
        let currencyName = this.props?.isLocal && this.props?.currencyName ? this.props?.currencyName :'USD';
        if(this.props?.isLocal && this.props?.currencyName &&  !this.props?.isCreateChild){
            plannedCost = 'planned_cost_local';
            totalBudget = 'campaign_total_budget_local';
            campaignFees = 'campaign_fees_local';
        }
        return (
            <div className='placement-details-table-summary-header'>
                    {
                        this.props.data && (<>
                            <div className="summary header-center">
                                <div className="mr-6">
                                {!this.props.campaignObj.isTotalBudget ?
                                    <>
                                        <h2 className='title is-2 mb-0' style={{ color: (this.getSum(plannedCost) > this.props.campaignObj[totalBudget] ? 'var(--text-error)' : 'var(--text-neutral-default)') }}>
                                            {this.getSum(plannedCost) ? this.getSum(plannedCost).toLocaleString('en-US', { style: "currency", currency: currencyName }) : 
                                            this.no_value.toLocaleString('en-US', { style: "currency", currency: currencyName })}
                                        </h2>
                                        <div className='is-size-7 header-left summary'>
                                        <OmniTooltipNextComponent className="mediaTooltip">
                                            <div slot="content">
                                                Media Budget: {PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(Number(this.props.campaignObj[totalBudget]),false,currencyName)}<br/>
                                                Fees: {PlacementDetailsTableService.getNumberWithTwoDigitsAfterDecimal(Number(this.props.campaignObj[campaignFees]),false,currencyName)}<br/>
                                            </div>
                                            <OmniIconComponent aria-label="alert" class="is-size-3" icon-id="omni:informative:financial"></OmniIconComponent>
                                        </OmniTooltipNextComponent>Net Media</div>
                                    </>:
                                    <>
                                        <h2 className='title is-2 mb-0'>
                                            {this.props.campaignObj[totalBudget]?this.convertIntoCurrency(this.props.campaignObj[totalBudget],currencyName) :
                                            this.no_value.toLocaleString('en-US', { style: "currency", currency: currencyName })}
                                        </h2>
                                        <div className='is-size-7 header-left summary'>
                                        <omni-icon part="financialIcon" class="is-size-4 cursor mr-3" icon-id="omni:informative:financial"></omni-icon>
                                        Net Media
                                        </div>
                                    </>
                                }
                                </div>
                                <div className="mr-6">
                                    <h2 className='title is-2 mb-0'>
                                        {this.getSum("unit_amount").toLocaleString('en-US', {maximumFractionDigits: this.currencyFractionDigits})}
                                    </h2>
                                    <div className='is-size-7 header-left summary'>Units</div>
                                </div>
                                
                                <div className="mr-6">
                                    <h2 className='title is-2 mb-0'>
                                        {this.getSum('ad_server_fee')?.toLocaleString('en-US', { style: "currency", currency: currencyName })}
                                    </h2>
                                    <div className='is-size-7 header-left summary'>Ad Serving Fee</div>
                                </div>
                                
                                <div className="mr-6">
                                    <h2 className='title is-2 mb-0'>
                                        {this.getSum('ad_verification_fee')?.toLocaleString('en-US', { style: "currency", currency: currencyName })}
                                    </h2>
                                    <div className='is-size-7 header-left summary'>Ad Verification Fee</div>
                                </div>
                                
                                <div className="mr-6">
                                    <h2 className='title is-2 mb-0' style={{ color: (this.getSum(plannedCost) > this.props.campaignObj.campaign_total_budget ? 'var(--text-error)' : 'var(--text-neutral-default)') }}>
                                        {this.getSum(plannedCost) +  this.getSum("ad_server_fee") + this.getSum("ad_verification_fee") ?
                                        ((this.getSum(plannedCost) +  this.getSum("ad_server_fee") + this.getSum("ad_verification_fee")).toLocaleString('en-US', { style: "currency", currency: currencyName }))
                                        : this.no_value.toLocaleString('en-US', { style: "currency", currency: currencyName })}
                                    </h2>
                                    <div className='is-size-7 header-left summary'>Total</div>
                                </div>
                            </div>
                        </>)
                    }
            </div>
        )
    }
}

export default React.memo(PlacementDetailsTableSummaryHeader);